import React from 'react';

import { SigningInSpinner } from '../authentication/components/loginSpace/SigningInSpinner';
import { PKCECodeChallenge, PKCEStore } from './PKCEStore';
import { PKCEUrls } from './PKCEUrls';

export interface GenerateCodeChallengeProps {
  readonly appUriProtocol: string;
  readonly openExternal?: string;
  readonly siteName?: string;
  readonly siteLuid?: string;
  readonly authSetting?: string;
  readonly embedded?: string;
}

export const GenerateCodeChallenge: React.FunctionComponent<GenerateCodeChallengeProps> = props => {
  React.useEffect(
    () => {
      let didCancel = false;
      PKCEStore.generateCodeChallenge()
        .then(codeChallenge => !didCancel &&
          redirectToGetAuthorizationCode(codeChallenge, props.appUriProtocol, props.openExternal, props.siteName, props.siteLuid, props.authSetting, props.embedded));
      return () => didCancel = true;
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <SigningInSpinner />;
};

function redirectToGetAuthorizationCode(
  codeChallenge: PKCECodeChallenge,
  appUriProtocol: string,
  openExternal?: string,
  targetSite?: string,
  targetSiteLuid?: string,
  authSetting?: string,
  embeddedVal?: string): void {
  const openExternalBool = openExternal ? openExternal === 'true' : true;
  const embedded = embeddedVal ? embeddedVal === 'true' : undefined;
  window.location.href = PKCEUrls.getAuthorizationCodeUrl(openExternalBool, {
    appUriProtocol,
    codeChallenge: codeChallenge.codeChallenge,
    codeChallengeMethod: codeChallenge.codeChallengeMethod,
    targetSite,
    targetSiteLuid,
    authSetting,
    embedded
  });
}
